import axios from "axios";
import AxiosClient from "../../../services/axios.services";

class MetricaCompetenciaServices {
  getMetricaCompetencias = params =>
    AxiosClient.get("/api/app/evaluacion_metrica_competencia/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });  
  getMetricaCompetencia = id =>
    AxiosClient.get(`/api/app/evaluacion_metrica_competencia/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveMetricaCompetencias = data =>
    AxiosClient.post("/api/app/evaluacion_metrica_competencia/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editMetricaCompetencias = (id, data) =>
    AxiosClient.put(
      `/api/app/evaluacion_metrica_competencia/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteMetricaCompetencias = id =>
    AxiosClient.delete(`/api/app/evaluacion_metrica_competencia/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new MetricaCompetenciaServices();